const Component = {
  render: function render() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c('div', [
      _c('h1', { staticClass: 'uk-h1 tm-heading-fragment' }, [_vm._v('Icons')]),
      _c('p', { staticClass: 'uk-text-lead' }, [
        _vm._v('Use icons with love, and moderation.')
      ]),
      _vm._v(' '),
      _c(
        'p',
        [
          _vm._v('If you followed the '),
          _c(
            'router-link',
            { staticClass: 'tm-internal-link', attrs: { to: 'integration' } },
            [_vm._v('integration guide')]
          ),
          _vm._v(', icons will be globally registered with a '),
          _c('code', [_vm._v('vk-icons')]),
          _vm._v(' prefix, eg. '),
          _c('code', [_vm._v('vk-icons-check')]),
          _vm._v(
            ', and we recommend to follow that convention for cross component compatibility. That way they will not conflict with other components plus will become easily recognizable.'
          )
        ],
        1
      ),
      _vm._v(' '),
      _c('hr', { staticClass: 'uk-margin-large' }),
      _vm._m(0),
      _vm._m(1),
      _vm._v(' '),
      _vm._m(2),
      _c('p', [
        _vm._v(
          "You don't have to register all the icons, on the contrary it would be best to cherry pick the ones you need."
        )
      ]),
      _vm._v(' '),
      _vm._m(3),
      _c(
        'p',
        [
          _c('vk-label', [_vm._v('Note')]),
          _vm._v(' Check the '),
          _c(
            'router-link',
            { staticClass: 'tm-internal-link', attrs: { to: 'icon' } },
            [_vm._v('Icon component')]
          ),
          _vm._v(' to render the icons with inherit styles and other benefits.')
        ],
        1
      ),
      _vm._v(' '),
      _c('hr', { staticClass: 'uk-margin-large' }),
      _vm._m(4),
      _vm._m(5),
      _vm._v(' '),
      _vm._m(6),
      _vm._v(' '),
      _vm._m(7),
      _vm._v(' '),
      _c('hr', { staticClass: 'uk-margin-large' }),
      _vm._m(8),
      _c('p', [
        _vm._v('Here is an overview of all currently available icons.')
      ]),
      _vm._v(' '),
      _vm._m(9),
      _vm._v(' '),
      _c(
        'div',
        [
          _c('vk-grid', { staticClass: 'uk-child-width-1-3@s' }, [
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'home' }
                    }),
                    _vm._v(' home')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'sign-in' }
                    }),
                    _vm._v(' sign-in')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'sign-out' }
                    }),
                    _vm._v(' sign-out')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'user' }
                    }),
                    _vm._v(' user')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'users' }
                    }),
                    _vm._v(' users')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'lock' }
                    }),
                    _vm._v(' lock')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'unlock' }
                    }),
                    _vm._v(' unlock')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'settings' }
                    }),
                    _vm._v(' settings')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'cog' }
                    }),
                    _vm._v(' cog')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'nut' }
                    }),
                    _vm._v(' nut')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'comment' }
                    }),
                    _vm._v(' comment')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'commenting' }
                    }),
                    _vm._v(' commenting')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'comments' }
                    }),
                    _vm._v(' comments')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'hashtag' }
                    }),
                    _vm._v(' hashtag')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'tag' }
                    }),
                    _vm._v(' tag')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'cart' }
                    }),
                    _vm._v(' cart')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'credit-card' }
                    }),
                    _vm._v(' credit-card')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'mail' }
                    }),
                    _vm._v(' mail')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'receiver' }
                    }),
                    _vm._v(' receiver')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'search' }
                    }),
                    _vm._v(' search')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'location' }
                    }),
                    _vm._v(' location')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'bookmark' }
                    }),
                    _vm._v(' bookmark')
                  ],
                  1
                )
              ])
            ]),
            _vm._v(' '),
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'code' }
                    }),
                    _vm._v(' code')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'paint-bucket' }
                    }),
                    _vm._v(' paint-bucket')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'camera' }
                    }),
                    _vm._v(' camera')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'bell' }
                    }),
                    _vm._v(' bell')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'bolt' }
                    }),
                    _vm._v(' bolt')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'star' }
                    }),
                    _vm._v(' star')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'heart' }
                    }),
                    _vm._v(' heart')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'happy' }
                    }),
                    _vm._v(' happy')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'lifesaver' }
                    }),
                    _vm._v(' lifesaver')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'rss' }
                    }),
                    _vm._v(' rss')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'social' }
                    }),
                    _vm._v(' social')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'git-branch' }
                    }),
                    _vm._v(' git-branch')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'git-fork' }
                    }),
                    _vm._v(' git-fork')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'world' }
                    }),
                    _vm._v(' world')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'calendar' }
                    }),
                    _vm._v(' calendar')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'clock' }
                    }),
                    _vm._v(' clock')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'history' }
                    }),
                    _vm._v(' history')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'future' }
                    }),
                    _vm._v(' future')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'pencil' }
                    }),
                    _vm._v(' pencil')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'trash' }
                    }),
                    _vm._v(' trash')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'move' }
                    }),
                    _vm._v(' move')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'link' }
                    }),
                    _vm._v(' link')
                  ],
                  1
                )
              ])
            ]),
            _vm._v(' '),
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'question' }
                    }),
                    _vm._v(' question')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'info' }
                    }),
                    _vm._v(' info')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'warning' }
                    }),
                    _vm._v(' warning')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'image' }
                    }),
                    _vm._v(' image')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'thumbnails' }
                    }),
                    _vm._v(' thumbnails')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'table' }
                    }),
                    _vm._v(' table')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'list' }
                    }),
                    _vm._v(' list')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'menu' }
                    }),
                    _vm._v(' menu')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'grid' }
                    }),
                    _vm._v(' grid')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'more' }
                    }),
                    _vm._v(' more')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'more-vertical' }
                    }),
                    _vm._v(' more-vertical')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'plus' }
                    }),
                    _vm._v(' plus')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'plus-circle' }
                    }),
                    _vm._v(' plus-circle')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'minus' }
                    }),
                    _vm._v(' minus')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'minus-circle' }
                    }),
                    _vm._v(' minus-circle')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'close' }
                    }),
                    _vm._v(' close')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'check' }
                    }),
                    _vm._v(' check')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'ban' }
                    }),
                    _vm._v(' ban')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'refresh' }
                    }),
                    _vm._v(' refresh')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'play' }
                    }),
                    _vm._v(' play')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'play-circle' }
                    }),
                    _vm._v(' play-circle')
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(' '),
      _vm._m(10),
      _vm._v(' '),
      _c(
        'div',
        [
          _c('vk-grid', { staticClass: 'uk-child-width-1-3@s' }, [
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'tv' }
                    }),
                    _vm._v(' tv')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'desktop' }
                    }),
                    _vm._v(' desktop')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'laptop' }
                    }),
                    _vm._v(' laptop')
                  ],
                  1
                )
              ])
            ]),
            _vm._v(' '),
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'tablet' }
                    }),
                    _vm._v(' tablet')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'phone' }
                    }),
                    _vm._v(' phone')
                  ],
                  1
                )
              ])
            ]),
            _vm._v(' '),
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'tablet-landscape' }
                    }),
                    _vm._v(' tablet-landscape')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'phone-landscape' }
                    }),
                    _vm._v(' phone-landscape')
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(' '),
      _vm._m(11),
      _vm._v(' '),
      _c(
        'div',
        [
          _c('vk-grid', { staticClass: 'uk-child-width-1-3@s' }, [
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'file' }
                    }),
                    _vm._v(' file')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'copy' }
                    }),
                    _vm._v(' copy')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'file-edit' }
                    }),
                    _vm._v(' file-edit')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'folder' }
                    }),
                    _vm._v(' folder')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'album' }
                    }),
                    _vm._v(' album')
                  ],
                  1
                )
              ])
            ]),
            _vm._v(' '),
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'push' }
                    }),
                    _vm._v(' push')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'pull' }
                    }),
                    _vm._v(' pull')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'server' }
                    }),
                    _vm._v(' server')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'database' }
                    }),
                    _vm._v(' database')
                  ],
                  1
                )
              ])
            ]),
            _vm._v(' '),
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'cloud-upload' }
                    }),
                    _vm._v(' cloud-upload')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'cloud-download' }
                    }),
                    _vm._v(' cloud-download')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'download' }
                    }),
                    _vm._v(' download')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'upload' }
                    }),
                    _vm._v(' upload')
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(' '),
      _vm._m(12),
      _vm._v(' '),
      _c(
        'div',
        [
          _c('vk-grid', { staticClass: 'uk-child-width-1-3@s' }, [
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'reply' }
                    }),
                    _vm._v(' reply')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'forward' }
                    }),
                    _vm._v(' forward')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'expand' }
                    }),
                    _vm._v(' expand')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'shrink' }
                    }),
                    _vm._v(' shrink')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'arrow-up' }
                    }),
                    _vm._v(' arrow-up')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'arrow-down' }
                    }),
                    _vm._v(' arrow-down')
                  ],
                  1
                )
              ])
            ]),
            _vm._v(' '),
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'arrow-left' }
                    }),
                    _vm._v(' arrow-left')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'arrow-right' }
                    }),
                    _vm._v(' arrow-right')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'chevron-up' }
                    }),
                    _vm._v(' chevron-up')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'chevron-down' }
                    }),
                    _vm._v(' chevron-down')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'chevron-left' }
                    }),
                    _vm._v(' chevron-left')
                  ],
                  1
                )
              ])
            ]),
            _vm._v(' '),
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'chevron-right' }
                    }),
                    _vm._v(' chevron-right')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'triangle-up' }
                    }),
                    _vm._v(' triangle-up')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'triangle-down' }
                    }),
                    _vm._v(' triangle-down')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'triangle-left' }
                    }),
                    _vm._v(' triangle-left')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'triangle-right' }
                    }),
                    _vm._v(' triangle-right')
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(' '),
      _vm._m(13),
      _vm._v(' '),
      _c(
        'div',
        [
          _c('vk-grid', { staticClass: 'uk-child-width-1-3@s' }, [
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'bold' }
                    }),
                    _vm._v(' bold')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'italic' }
                    }),
                    _vm._v(' italic')
                  ],
                  1
                )
              ])
            ]),
            _vm._v(' '),
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'strikethrough' }
                    }),
                    _vm._v(' strikethrough')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'video-camera' }
                    }),
                    _vm._v(' video-camera')
                  ],
                  1
                )
              ])
            ]),
            _vm._v(' '),
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'quote-right' }
                    }),
                    _vm._v(' quote-right')
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(' '),
      _vm._m(14),
      _vm._v(' '),
      _c(
        'div',
        [
          _c('vk-grid', { staticClass: 'uk-child-width-1-3@s' }, [
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: '500px' }
                    }),
                    _vm._v(' 500px')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'behance' }
                    }),
                    _vm._v(' behance')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'dribbble' }
                    }),
                    _vm._v(' dribbble')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'facebook' }
                    }),
                    _vm._v(' facebook')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'flickr' }
                    }),
                    _vm._v(' flickr')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'foursquare' }
                    }),
                    _vm._v(' foursquare')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'github' }
                    }),
                    _vm._v(' github')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'github-alt' }
                    }),
                    _vm._v(' github-alt')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'gitter' }
                    }),
                    _vm._v(' gitter')
                  ],
                  1
                )
              ])
            ]),
            _vm._v(' '),
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'google' }
                    }),
                    _vm._v(' google')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'google-plus' }
                    }),
                    _vm._v(' google-plus')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'instagram' }
                    }),
                    _vm._v(' instagram')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'joomla' }
                    }),
                    _vm._v(' joomla')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'linkedin' }
                    }),
                    _vm._v(' linkedin')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'pagekit' }
                    }),
                    _vm._v(' pagekit')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'pinterest' }
                    }),
                    _vm._v(' pinterest')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'soundcloud' }
                    }),
                    _vm._v(' soundcloud')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'tripadvisor' }
                    }),
                    _vm._v(' tripadvisor')
                  ],
                  1
                )
              ])
            ]),
            _vm._v(' '),
            _c('div', [
              _c('ul', { staticClass: 'uk-list' }, [
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'tumblr' }
                    }),
                    _vm._v(' tumblr')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'twitter' }
                    }),
                    _vm._v(' twitter')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'uikit' }
                    }),
                    _vm._v(' uikit')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'vimeo' }
                    }),
                    _vm._v(' vimeo')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'whatsapp' }
                    }),
                    _vm._v(' whatsapp')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'wordpress' }
                    }),
                    _vm._v(' wordpress')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'xing' }
                    }),
                    _vm._v(' xing')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'yelp' }
                    }),
                    _vm._v(' yelp')
                  ],
                  1
                ),
                _vm._v(' '),
                _c(
                  'li',
                  [
                    _c('vk-icon', {
                      staticClass: 'uk-margin-small-right',
                      attrs: { icon: 'youtube' }
                    }),
                    _vm._v(' youtube')
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        1
      )
    ])
  },
  staticRenderFns: [
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'usage' } },
        [_c('a', { attrs: { href: '#usage' } }, [_vm._v('Usage')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v('As long as the icons are registered with the '),
        _c('code', [_vm._v('vk-icons')]),
        _vm._v(
          ' prefix you can reference them by the name across the different components supporting them.'
        )
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-icons-check')
              ]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('attrs')]),
              _vm._v('>')
            ]),
            _vm._v('...'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [
                _vm._v('vk-icons-check')
              ]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-js hljs' }, [
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('import')]),
            _vm._v(' Vue '),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('from')]),
            _vm._v(' '),
            _c('span', { staticClass: 'hljs-string' }, [_vm._v("'vue'")]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('import')]),
            _vm._v(' { IconCheck, IconClose } '),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('from')]),
            _vm._v(' '),
            _c('span', { staticClass: 'hljs-string' }, [
              _vm._v("'@vuikit/icons'")
            ]),
            _vm._v('\n\n'),
            _c('span', { staticClass: 'hljs-comment' }, [
              _vm._v('// register globally')
            ]),
            _vm._v('\nVue.component('),
            _c('span', { staticClass: 'hljs-string' }, [
              _vm._v("'VkIconsCheck'")
            ]),
            _vm._v(', IconCheck)\nVue.component('),
            _c('span', { staticClass: 'hljs-string' }, [
              _vm._v("'VkIconsClose'")
            ]),
            _vm._v(', IconClose)\n\n'),
            _c('span', { staticClass: 'hljs-comment' }, [
              _vm._v('// or locally')
            ]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('export')]),
            _vm._v(' '),
            _c('span', { staticClass: 'hljs-keyword' }, [_vm._v('default')]),
            _vm._v(' {\n  '),
            _c('span', { staticClass: 'hljs-attr' }, [_vm._v('components')]),
            _vm._v(': {\n    '),
            _c('span', { staticClass: 'hljs-attr' }, [_vm._v('VkIconsCheck')]),
            _vm._v(': IconCheck,\n    '),
            _c('span', { staticClass: 'hljs-attr' }, [_vm._v('VkIconsClose')]),
            _vm._v(': IconClose\n  }\n} ')
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        {
          staticClass: 'uk-h2 tm-heading-fragment',
          attrs: { id: 'custom-icons' }
        },
        [
          _c('a', { attrs: { href: '#custom-icons' } }, [
            _vm._v('Custom Icons')
          ])
        ]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v(
          'If you want to register your own collection of icons make sure those are functional components, returning a raw '
        ),
        _c('code', [_vm._v('svg')]),
        _vm._v(
          " element and registered globally or locally as described above. That's important as the components supporting icons would expect that."
        )
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v(
          'You can convert the svg files to Vue functional components on your own way, but you can also use the '
        ),
        _c(
          'a',
          {
            attrs: {
              href:
                'https://github.com/vuikit/vuikit/tree/next/packages/vuikit-icons#custom-icons',
              target: '_blank'
            }
          },
          [_vm._v('Vuikit Icons build')]
        ),
        _vm._v(' process which will make the conversion for you.')
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v('Additionally, if using Webpack the '),
        _c(
          'a',
          {
            attrs: {
              href: 'https://github.com/vuikit/vuikit-icons-loader',
              target: '_blank'
            }
          },
          [_vm._v('Vuikit Icons loader')]
        ),
        _vm._v(' will do the conversion on the fly. Pretty neat!')
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'library' } },
        [_c('a', { attrs: { href: '#library' } }, [_vm._v('Library')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('h4', { staticClass: 'uk-heading-line' }, [
        _c('span', [_vm._v('App')])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('h4', { staticClass: 'uk-heading-line' }, [
        _c('span', [_vm._v('Devices')])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('h4', { staticClass: 'uk-heading-line' }, [
        _c('span', [_vm._v('Storage')])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('h4', { staticClass: 'uk-heading-line' }, [
        _c('span', [_vm._v('Direction')])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('h4', { staticClass: 'uk-heading-line' }, [
        _c('span', [_vm._v('Editor')])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('h4', { staticClass: 'uk-heading-line' }, [
        _c('span', [_vm._v('Brands')])
      ])
    }
  ],
  data: function() {
    return {}
  },
  scrollToTop: true,
  sections: [
    { id: 'usage', title: 'Usage' },
    { id: 'custom-icons', title: 'Custom Icons' },
    { id: 'library', title: 'Library' }
  ],
  components: {}
}


export default Component
